<script>
import { createNewWorkoutLog, getAllExistingWorkoutLogDates } from '@/services/WorkoutServices';

export default {
  data() {
    return {
      // HELPERS
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),
      allWorkouts: {},
      // ACCORDIONS TOGGLE CONTROL
      accordionLogistics: null,
      accordionWarmup: null,
      accordionWorkout: 0,
      accordionCooldown: null,
      // DB - LOGISTICS
      date: null,
      time: null,
      location: '',
      generalNotes: '',
      // DB - DATA FROM SECTIONS
      warmup: '',
      workout: [],
      cooldown: '',
      // FORM - ADD EXERCISE TO WORKOUT
      exerciseName: '',
      exerciseNote: '',
      // FORM - ADD SET TO EXERCISE
      setReps: 1,
      setWeight: '',
      setNote: '',
      //
      showSaveModal: false,
    };
  },
  computed: {
    allWorkoutsDates() {
      return Object.keys(this.allWorkouts).length ? Object.keys(this.allWorkouts) : [];
    },
    dateOptions() {
      let baseDateStr = this.date?.value || this.getTodayLocalYYYYMMDD();

      // Parse as local date safely
      const [year, month, day] = baseDateStr.split('-').map(Number);
      const today = new Date(year, month - 1, day);   // ← this is the key

      const options = [];

      for (let i = -3; i <= 3; i++) {
        const d = new Date(today);
        d.setDate(today.getDate() + i);

        const days = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];
        const display = `${days[d.getDay()]}, ${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;

        // Generate value in local YYYY-MM-DD
        const value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

        options.push({ display, value });
      }

      return options;
    },
    //
    canAddExerciseToWorkout() {
      return this.exerciseName.trim().length > 0;
    },
    canFinishAndSaveWorkout() {
      return this.date && this.time && this.trimmedWorkout.length > 0;
    },
    trimmedWorkout() {
      let tw = [];

      for (let i = 0; i < this.workout.length; i++) {
        const exercise = this.workout[i];
        let cleanedExercise = {
          exerciseName: exercise.exerciseName.trim(),
          sets: [],
        };
        if ( exercise.exerciseNote?.trim().length ) cleanedExercise.exerciseNote = exercise.exerciseNote.trim();

        for (let s = 0; s < exercise.sets.length; s++) {
          const set = exercise.sets[s];
          let cleanedSet = {
            reps: set.reps,
          };
          if ( set.weight?.trim().length ) cleanedSet.weight = set.weight.trim();
          if ( set.note?.trim().length ) cleanedSet.note = set.note.trim();
          cleanedExercise.sets.push(cleanedSet);
        }

        tw.push(cleanedExercise);
      }
      return tw;
    },
    
  },
  methods: {
    // HELPERS
    getTodayLocalYYYYMMDD() {
      const now = new Date();
      return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    },
    createLocalDateObject() {
      const today = new Date();
      const days = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];

      return {
        display: `${days[today.getDay()]}, ${today.getMonth()+1}/${today.getDate()}/${today.getFullYear()}`,
        value: `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`
      };
    },
    getNowTime() {
      const today = new Date();

      let hours = today.getHours();
      const minutes = today.getMinutes().toString().padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;

      return `${hours}:${minutes} ${ampm}`;
    },
    loadDraftFromCookie() {
      const draft = this.$cookies.get('workoutDraft');
      if (!draft) return false;

      try {
        this.date = draft.date || this.date;
        this.time = draft.time || this.time;
        this.location = draft.location || '';
        this.generalNotes = draft.generalNotes || '';
        this.warmup = draft.warmup || '';
        this.workout = draft.workout || [];
        this.cooldown = draft.cooldown || '';

        // console.log('*** 🔄 Loaded draft from cookie ***', draft);
        return true;
      } catch (e) {
        console.error('Failed to load workout draft', e);
        this.$cookies.remove('workoutDraft');
        return false;
      }
    },
    async saveWorkoutToCookie() {
      // console.log('*** starting saveWorkoutToCookie() ***');
      // console.log('*** trimedWorkout ***', this.trimmedWorkout);

      const draftData = {
        date: this.date,
        time: this.time,
        location: this.location,
        generalNotes: this.generalNotes,
        warmup: this.warmup,
        workout: [ ...this.workout],
        cooldown: this.cooldown,
      };

      this.$cookies.remove('workoutDraft');
      await this.$nextTick();
      this.$cookies.set('workoutDraft', draftData, '8h');

      // console.log('*** Workout draft saved to cookie (8h) ***', draftData);
    },
    deleteDraftAndStartFromFresh() {
      // console.log('*** starting deleteDraftAndStartFromFresh() ***');

      this.$cookies.remove('workoutDraft');

      // RESET DATE & TIME
      this.date = this.createLocalDateObject();
      this.time = this.getNowTime();

      // RESET FORM FIELDS
      this.location = '';
      this.generalNotes = '';
      this.warmup = '';
      this.workout = [];
      this.cooldown = '';
      //
      this.exerciseName = '';
      this.exerciseNote = '';
      //
      this.setReps = 1;
      this.setWeight = '';
      this.setNote = '';

      // RE-TOGGLE ACCORDIONS
      this.accordionWarmup = this.accordionWorkout = this.accordionCooldown = null;
      this.accordionLogistics = 0;

      // console.log('*** 🗑️ Draft deleted — fresh workout started ***');
    },
    // SAVE DRAFT buttons
    async saveDraftLogistics() {
      this.saveWorkoutToCookie();
      await this.$nextTick();
      const l = document.getElementById('logistics-accordion-title');
      if (l) { l.click(); }
    },
    saveDraftWarmup() {
      this.saveWorkoutToCookie();
      this.accordionWarmup = null;
      this.accordionWorkout = 0;
    },
    saveDraftCooldown() {
      this.saveWorkoutToCookie();
      this.accordionCooldown = null;
    },
    // MANAGE THIS.WORKOUT
    addExerciseToWorkout() {
      // console.log('*** addExerciseToWorkout() ***', this.exerciseName, this.exerciseNote);

      // add exercise to workout
      this.workout.push({
        exerciseName: this.exerciseName,
        exerciseNote: this.exerciseNote,
        sets: [],
      });
      this.saveWorkoutToCookie();

      // reset form
      this.exerciseName = this.exerciseNote = '';
      this.accordionWorkout = this.workout.length;
    },
    addSetToExercise(exerciseIndex) {
      // console.log('*** starting addSetToExercise() ***', exerciseIndex, this.setReps, this.setWeight, this.setNote);

      // add set to exercise
      let set = {
        reps: parseInt(this.setReps)
      };
      if (this.setWeight?.trim().length) set.weight = this.setWeight.trim();
      if (this.setNote?.trim().length) set.note = this.setNote.trim();
      this.workout[exerciseIndex]?.sets.push(set);

      // save & reset
      this.saveWorkoutToCookie();
      this.setReps = 1;
      this.setWeight = '';
      this.setNote = '';

    },
    deleteSetFromExercise(exerciseIndex, setIndex) {
      // console.log('*** starting deleteSetFromExercise() ***', exerciseIndex, setIndex);
      this.workout[exerciseIndex].sets.splice(setIndex, 1);
      this.saveWorkoutToCookie();
    },
    // SAVE WORKOUT TO DBASE
    async finishWorkoutAndSaveToDbase() {
      // console.log('*** starting finishWorkoutAndSaveToDbase() ***');

      // form the Workout Log object
      let newWorkoutLog = {
        date: this.date,
        time: this.time,
        workout: this.trimmedWorkout,
      };
      if (this.location.trim().length) newWorkoutLog.location = this.location.trim();
      if (this.generalNotes.trim().length) newWorkoutLog.generalNotes = this.generalNotes.trim();
      if (this.warmup.trim().length) newWorkoutLog.warmup = this.warmup.trim();
      if (this.cooldown.trim().length) newWorkoutLog.cooldown = this.cooldown.trim();

      // form the :workoutID
      let saveDate = this.date.value;
      const dateCount = this.allWorkoutsDates.filter(d => d.includes(saveDate)).length;
      if (dateCount) saveDate = this.date.value + '-' + dateCount;

      // make the call
      const successfullyCreatedNewWorkoutLog = await createNewWorkoutLog(this.uId, this.token, saveDate, newWorkoutLog);

      // handle success
      if (successfullyCreatedNewWorkoutLog) {
        this.showSaveModal = false;
        await this.$nextTick();

        this.deleteDraftAndStartFromFresh();
        await this.$nextTick();

        this.$router.push('/workouts');
      }

    },

  },
  async created() {
    console.clear();

    // Try to load existing draft first
    const hadDraft = this.loadDraftFromCookie();

    if (!hadDraft) {
      this.date = this.createLocalDateObject();
      this.time = this.getNowTime();
    }

    // control accordions
    this.accordionLogistics = !this.warmup.length && !this.workout.length ? 0 : null;
    this.accordionWarmup = this.warmup.length && this.workout.length ? null : 0;
    this.accordionWorkout = this.warmup.length && this.workout.length ? this.workout.length : null;


    this.allWorkouts = await getAllExistingWorkoutLogDates(this.uId, this.token) || [];

  },
  mounted() {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    this.autoSaveInterval = setInterval(() => {
      // console.log('*** autosave ***');
      this.saveWorkoutToCookie();
    }, 45 * 1000); // autosave every 45 seconds

    // Extra safety net
    window.addEventListener('beforeunload', () => this.saveWorkoutToCookie());
  },
  beforeUnmount() {
    if (this.autoSaveInterval) clearInterval(this.autoSaveInterval);
  },
}
</script>

<template>
<div id="page-workout-log" class="px-4 pb-16 mb-16">
  <div id="page-header" class="pt-4 pb-2">
    <div class="d-flex justify-space-between">
      <v-btn @click.prevent="deleteDraftAndStartFromFresh"
             variant="outlined"
             density="compact"
             class="px-2 text-body-2 text-red-lighten-2 font-italic"
      >Delete Workout & Start Fresh</v-btn>
      <p class="text-right text-body-2 font-italic">Questions? Check the <router-link to="/faq">FAQs</router-link>.</p>
    </div>
    <h1 class="my-2 text-center text-uppercase">Workout Log</h1>
  </div> <!-- end #page-header -->

  <!-- LOGISTICS -->
  <div id="container-logistics">
    <v-expansion-panels v-model="accordionLogistics" variant="popout">
      <v-expansion-panel bg-color="blue-lighten-4">
        <v-expansion-panel-title id="logistics-accordion-title" class="text-h6 text-uppercase">
          {{ date.display}}&nbsp;&nbsp;—&nbsp;&nbsp;{{ time }}
        </v-expansion-panel-title>
        <v-expansion-panel-text class="pt-4">
          <!-- Date & Time -->
          <div class="d-flex">

            <div id="logistics-date" class="w-50">
              <p><b>Date</b></p>
              <v-select v-model="date"
                        :items="dateOptions"
                        item-title="display"
                        item-value="value"
                        :return-object="true"
                        variant="outlined"
                        density="compact"
                        hide-details
              ></v-select>
            </div>

            <div id="logistics-time" class="w-50 ps-8">
              <p><b>Time</b></p>
              <v-text-field v-model="time"
                            variant="outlined"
                            density="compact"
                            hide-details
                            placeholder="7:58 PM"
              ></v-text-field>
            </div>

          </div> <!-- end Date & Time -->

          <!-- Location -->
          <div class="mt-4 d-flex">
            <p class="mt-2 me-4 text-body-2">Location</p>
            <div class="w-100">
              <v-textarea v-model="location"
                          rows="1"
                          auto-grow
                          clearable
                          variant="outlined"
                          density="compact"
              ></v-textarea>
            </div>
          </div> <!-- end Location -->

          <!-- General Notes -->
          <div class="d-flex">
            <p class="me-4 text-body-2 text-center">General <br />Notes</p>
            <v-textarea v-model="generalNotes"
                        rows="1"
                        auto-grow
                        clearable
                        variant="outlined"
                        density="compact"
            ></v-textarea>
          </div> <!-- end General Notes -->

          <div class="d-flex justify-end">
            <v-btn @click.prevent="saveDraftLogistics"
                   color="grey"
                   density="compact"
                   class="text-capitalize px-2"
            >Save Draft</v-btn>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div> <!-- end #logistics -->

  <!-- WARM-UP -->
  <div id="container-warmup" class="mt-8 mb-16">
    <v-expansion-panels v-model="accordionWarmup" variant="popout">
      <v-expansion-panel>
        <v-expansion-panel-title id="warmup-accordion-title" class="text-h6">WARM-UP</v-expansion-panel-title>
        <v-expansion-panel-text class="pt-4">
          <v-textarea v-model="warmup"
                      rows="1"
                      auto-grow
                      clearable
                      variant="outlined"
                      density="comfortable"
                      placeholder="arm circles, leg swings, ..."
          ></v-textarea>
          <div class="d-flex justify-end">
            <v-btn @click.prevent="saveDraftWarmup"
                   color="grey"
                   density="compact"
                   class="text-capitalize px-2"
            >Save Draft</v-btn>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>

  <!-- WORKOUT -->
  <div id="container-workout" class="my-16">
    <h3 class="ms-2 text-h6">WORKOUT</h3>
    <v-expansion-panels v-model="accordionWorkout" variant="popout">

      <!-- ADD EXERCISE TO WORKOUT -->
      <v-expansion-panel bg-color="red-lighten-5">
        <v-expansion-panel-title id="accordion-add-exercise-to-workout" class="text-h6">Add an Exercise to the Workout</v-expansion-panel-title>
        <v-expansion-panel-text class="py-4">
          <v-textarea v-model="exerciseName"
                      rows="1"
                      auto-grow
                      clearable
                      variant="outlined"
                      density="comfortable"
                      label="Exercise Name"
                      placeholder="Pull-Ups"
          ></v-textarea>
          <v-textarea v-model="exerciseNote"
                      rows="1"
                      auto-grow
                      clearable
                      variant="outlined"
                      density="comfortable"
                      label="Exercise Note / Description"
          ></v-textarea>
          <div class="d-flex justify-center">
            <v-btn @click.prevent="addExerciseToWorkout"
                   :color="canAddExerciseToWorkout ? 'green-lighten-1' : 'grey'"
                   :disabled="!canAddExerciseToWorkout"
                   density="compact"
            >Add Exercise to Workout</v-btn>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>


      <!-- LIST OF EXERCISES - one accordion per Exercise -->
      <v-expansion-panel v-for="(exercise, exerciseIndex) in workout" :key="exerciseIndex" color="green-lighten-5" class="pa-0 px-sm-4">
        <v-expansion-panel-title class="text-h6">({{ exerciseIndex+1 }})  {{ exercise.exerciseName }}</v-expansion-panel-title>
        <v-expansion-panel-text>
          <p v-if="exercise.exerciseNote" class="mb-6 text-body-2"><i>{{ exercise.exerciseNote }}</i></p>

          <!-- SETS HEADER -->
          <div class="mt-4 d-flex justify-center">
            <p class="w-33 border py-2 text-center"><b>#</b></p>
            <p class="w-33 border py-2 text-center"><b>Reps</b></p>
            <p class="w-33 border py-2 text-center"><b>Weight</b></p>
          </div>

          <!-- EXISTING SETS & REPS -->
          <div v-for="(set, setIndex) in exercise.sets" :key="setIndex"
               class="exercise-sets mt-4 mb-2"
          >
            <div class="d-flex justify-center">
              <div class="w-33 text-center">
                <p><b>Set {{ setIndex+1 }}</b></p>
              </div>
              <p class="w-33 text-center"><b>{{ set.reps }}</b></p>
              <p class="w-33 text-center">{{ set.weight }}</p>
            </div>

            <p v-if="set.note" class="mx-8 my-3 text-body-2"><i>note: {{ set.note }}</i></p>

            <p @click.prevent="deleteSetFromExercise(exerciseIndex, setIndex)"
               class="delete-set text-center text-body-2 text-red-lighten-2"
            ><i>Delete set</i></p>

            <hr class="my-6" />
          </div> <!-- end EXISTING SETS -->

          <!-- NEW SET / REPS -->
          <div id="container-add-set-to-exercise">

            <!-- mobile -->
            <div class="d-flex d-sm-none py-4 w-100">
              <p class="w-33 text-center"><b>Set {{ workout[exerciseIndex].sets.length + 1 }}</b></p>
              <div class="w-75">
                <v-number-input v-model="setReps"
                                label="Reps"
                                :min="1"
                                variant="outlined"
                                controlVariant="split"
                                inset
                                class="w-100 text-center"
                ></v-number-input>
                <v-text-field v-model="setWeight"
                              label="Weight"
                              variant="outlined"
                              class="w-100 text-center"
                ></v-text-field>
              </div>
            </div>
            <!-- tablet & bigger -->
            <div class="d-none d-sm-flex py-4">
              <p class="w-33 text-center"><b>Set {{ workout[exerciseIndex].sets.length + 1 }}</b></p>
              <v-number-input v-model="setReps"
                              :min="1"
                              variant="outlined"
                              controlVariant="split"
                              inset
                              class="w-33 text-center"
              ></v-number-input>
              <v-text-field v-model="setWeight"
                            variant="outlined"
                            class="w-33 ms-2 text-center"
              ></v-text-field>
            </div>
            <!-- note about this set -->
            <div class="d-flex justify-center">
              <v-textarea v-model="setNote"
                          rows="1"
                          auto-grow
                          clearable
                          variant="outlined"
                          density="compact"
                          label="note about this set"
                          class="new-set-note"
              ></v-textarea>
            </div>

            <!-- btn -->
            <div class="d-flex justify-center">
              <v-btn @click.prevent="addSetToExercise(exerciseIndex)"
                     density="comfortable"
                     :color="setReps ? 'blue-lighten-2' : 'grey'"
                     :disabled="!setReps"
                     class="text-body-2 text-white font-italic"
              >Log this Set</v-btn>
            </div>
          </div>

        </v-expansion-panel-text>
      </v-expansion-panel>


    </v-expansion-panels> <!-- end WORKOUT accordion -->
  </div>

  <!-- COOL-DOWN -->
  <div id="container-cooldown" class="mt-16 pt-16">
    <v-expansion-panels v-model="accordionCooldown" variant="popout">
      <v-expansion-panel>
        <v-expansion-panel-title id="cooldown-accordion-title" class="text-h6">COOL-DOWN</v-expansion-panel-title>
        <v-expansion-panel-text class="pt-4">
          <v-textarea v-model="cooldown"
                      rows="1"
                      auto-grow
                      clearable
                      variant="outlined"
                      density="comfortable"
                      placeholder="walking, standing calf stretch, ..."
          ></v-textarea>
          <div class="d-flex justify-end">
            <v-btn @click.prevent="saveDraftCooldown"
                   color="grey"
                   density="compact"
                   class="text-capitalize px-2"
            >Save Draft</v-btn>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>

  <div id="container-save" class="mt-16 pt-12 d-flex justify-center">
    <v-btn @click.prevent="showSaveModal = true"
           :color="canFinishAndSaveWorkout ? 'green-lighten-1' : 'grey-lighten-5'"
           :disabled="!canFinishAndSaveWorkout"
    >Finish & Save Workout</v-btn>
  </div>

  <!-- MODAL: REVIEW & CONFIRM THE DRAFT BEFORE SAVING -->
  <v-dialog v-model="showSaveModal"
            fullscreen
  >
    <v-card>
      <v-toolbar>
        <v-btn @click.prevent="showSaveModal = false"
          icon="mdi-close"
        ></v-btn>
        <h2>Confirm & Save Workout</h2>
      </v-toolbar>

      <div id="modal-save-content" class="pa-4 bg-yellow-lighten-5">
        <div class="modal-save mb-8 d-flex flex-column align-center">
          <h3 class="mb-3 font-italic">Does everything look accurate?</h3>
          <v-btn @click.prevent="finishWorkoutAndSaveToDbase"
                 color="green-lighten-1"
                 class="border"
          >Confirm & Save Workout</v-btn>
          <v-btn @click.prevent="showSaveModal = false"
                 color="red-lighten-3"
                 variant="outlined"
                 density="compact"
                 class="mt-8 px-2 text-lowercase"
          >Cancel</v-btn>
        </div>

        <div id="modal-logistics">
          <p><b class="me-2">Date:</b> <u>{{ date.display }}</u></p>
          <p><b class="me-2">Time:</b> {{ time }}</p>
          <p class="allow-pre-line"><b class="me-2">Location:</b> {{ location.trim().length ? location : ' n/a' }}</p>
          <p class="allow-new-line"><b class="me-2">General Notes:</b> {{ generalNotes.trim().length ? generalNotes : ' n/a' }}</p>
        </div>
        <div id="modal-warmup" class="my-8">
          <h3><u>Warm-Up</u></h3>
          <p class="allow-new-line">{{ warmup.trim().length ? warmup : 'n/a'}}</p>
        </div>
        <div id="modal-workout">
          <h3><u>Workout</u></h3>

          <!-- one single exercise -->
          <div v-for="(exercise, exerciseIndex) in workout"
               :key="exerciseIndex"
               class="one-exercise pa-2 pb-4 mb-6 bg-grey-lighten-4 rounded-lg"
          >
            <h4 class="text-uppercase">{{ exercise.exerciseName }}</h4>

            <p v-if="exercise.exerciseNote"
               class="text-body-2 font-italic allow-new-line"
            >
              <b>Exercise Note/Description:</b> {{ exercise.exerciseNote }}
            </p>

            <div class="d-flex justify-center">
              <div class="py-3 w-33 text-center font-weight-bold border">#</div>
              <div class="py-3 w-33 text-center font-weight-bold border">Reps</div>
              <div class="py-3 w-33 text-center font-weight-bold border">Weight</div>
            </div>

            <div v-for="(set, setIndex) in exercise.sets" :key="setIndex"
                 class="pt-4 d-flex justify-center flex-wrap"
            >
              <div class="w-33 text-center font-weight-bold">Set {{ setIndex+1 }}</div>
              <div class="w-33 text-center">{{ set.reps }}</div>
              <div class="w-33 text-center">{{ set.weight }}</div>
              <div v-if="set.note" class="mx-12 w-100 allow-new-line text-body-2 font-italic">{{ set.note }}</div>
              <hr v-if="setIndex < exercise.sets.length -1" class="mt-4 w-100" />
            </div>

          </div> <!-- end exercise -->

        </div> <!-- end #workout -->
        <div id="modal-cooldown" class="my-8">
          <h3><u>Cool-Down</u></h3>
          <p class="allow-new-line">{{ cooldown.trim().length ? cooldown : 'n/a' }}</p>
        </div>
        <div class="modal-save mb-8 d-flex flex-column align-center">
          <h3 class="mb-3 font-italic">Does everything look accurate?</h3>
          <v-btn @click.prevent="finishWorkoutAndSaveToDbase"
                 color="green-lighten-1"
                 class="border"
          >Confirm & Save Workout</v-btn>
          <v-btn @click.prevent="showSaveModal = false"
                 color="red-lighten-3"
                 variant="outlined"
                 density="compact"
                 class="mt-8 mb-16 px-2 text-lowercase"
          >Cancel</v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>


</div>
</template>

<style scoped lang="scss">
.allow-new-line {
  white-space: pre-line;
}
#page-workout-log {
  max-width: 700px;
  margin: 0 auto;

  #container-workout {
    .new-set-note { max-width: 510px; }
    .delete-set:hover { cursor: pointer; }
  }
}
</style>
